import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiDataSources {
  static createDataSource(appId, model) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/data_sources`, {
      method: "POST",
      body: { data_source: model },
    });
  }

  static getDataSources(appId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/data_sources`);
  }

  static upsertFromCSV(appId, dataSourceId, csv) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/data_sources/${dataSourceId}/upsert_from_csv`, {
      method: "POST",
      body: { csv_file: csv },
    });
  }

  static deleteDataSource(appId, dataSourceId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/data_sources/${dataSourceId}`, {
      method: "DELETE",
    });
  }

  static editDataSource(appId, model) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/data_sources/${model.id}`, {
      method: "PUT",
      body: { data_source: model },
    });
  }
}
